"use strict";
/**
 * Message types for LinkedIn Sales Navigator filter operations
 * Used by extension content script and webapp/background script
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINKEDIN_SN_MESSAGE_TYPES = void 0;
exports.LINKEDIN_SN_MESSAGE_TYPES = {
    APPLY_FILTERS: "LINKEDIN_SN_APPLY_FILTERS",
    CLEAR_FILTERS: "LINKEDIN_SN_CLEAR_FILTERS",
    CHECK_STATUS: "LINKEDIN_SN_CHECK_STATUS",
    GET_RESULT_COUNT: "LINKEDIN_SN_GET_RESULT_COUNT",
    SCRAPE_VISIBLE_PROFILES: "LINKEDIN_SN_SCRAPE_VISIBLE_PROFILES",
    SCRAPE_ALL_ON_PAGE: "LINKEDIN_SN_SCRAPE_ALL_ON_PAGE",
    SCRAPE_ALL_ON_PAGE_SLOW: "LINKEDIN_SN_SCRAPE_ALL_ON_PAGE_SLOW",
    GO_TO_NEXT_PAGE: "LINKEDIN_SN_GO_TO_NEXT_PAGE",
    GO_TO_PREV_PAGE: "LINKEDIN_SN_GO_TO_PREV_PAGE",
    NAVIGATE_TO_PAGE: "LINKEDIN_SN_NAVIGATE_TO_PAGE",
    GET_PAGINATION_INFO: "LINKEDIN_SN_GET_PAGINATION_INFO",
    FETCH_AUTOCOMPLETE: "LINKEDIN_SN_FETCH_AUTOCOMPLETE",
};
